import { NgClass, NgFor, NgIf } from '@angular/common';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';

import { MdbModalRef, MdbModalService } from 'mdb5-adapted';
import { NgxPaginationModule, PaginationInstance } from 'ngx-pagination';
import { MenuService } from 'src/app/core/rest-services/menu.service';
import { ConfirmDialogComponent } from 'src/app/shared/dialogs/confirm-dialog/confirm-dialog.component';

import { LmsTableWrapperComponent } from '@lmsShared';

import { MenusDialogComponent } from '../menus-dialog/menus-dialog.component';

@Component({
  selector: 'app-menus-admin',
  templateUrl: './menus-admin.component.html',
  styleUrls: ['./menus-admin.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    NgFor,
    NgIf,
    NgClass,
    NgxPaginationModule,
    LmsTableWrapperComponent,
  ],
})
export class MenusAdminComponent implements OnInit {
  menusAdminForm: FormGroup;
  menus: any;

  config: PaginationInstance = {
    id: 'pager',
    itemsPerPage: 10,
    currentPage: 1,
  };

  constructor(
    private formBuilder: FormBuilder,
    private editDialog: MdbModalService,
    private router: Router,
    public dialog: MdbModalRef<MenusDialogComponent>,
    private menuService: MenuService // private _database: ChecklistDatabase
  ) {
  }

  ngOnInit(): void {
    this.menusAdminForm = this.formBuilder.group({});
    this.findAll();
  }


  findAll() {
    this.menuService.findAll().subscribe((res: any) => {
      this.menus = res;
    });
  }

  editMenu(menu: any) {
    const dialogConfig = {
      modalClass: 'modal-dialog container-fluid',
      data: { menu: menu }
    };

    const dialogRef = this.editDialog.open(MenusDialogComponent, dialogConfig);

    dialogRef.onClose.subscribe((dlgmenu) => {
    });
  }

  deleteMenu(menu: any) {
    const dialogRef = this.editDialog.open(ConfirmDialogComponent, {
      modalClass: 'modal modal-dialog d-flex',
      data: {
        title: 'Menu Delete',
        message: 'Are you sure you want to delete?',
      },
    });

    dialogRef.onClose.subscribe((dialogResult) => {
      const confirmResult = dialogResult;

      if (confirmResult == true) {
        for (const b in menu.submenus) {
          const parentMenu = { id: menu.id };
          const newSubmenu = {
            submenu: menu.submenus[b].submenu,
            component: menu.submenus[b].component,
            menu: parentMenu,
          };
          menu.submenus[b] = newSubmenu;
        }

        this.menuService.delete(menu).subscribe((res: any) => {
          this.menus = res;
          this.router.navigate(['/menuAdmin']);
        });
      }
    });
  }

  addMenu() {
    const submenus: any = [];
    const menu = {
      id: 0,
      menu: '',
      component: '',
      userRole: '',
      hasSubmenu: '',
      trigger: '',
      submenus: submenus,
    };

    const dialogRef = this.editDialog.open(ConfirmDialogComponent, {
      modalClass: 'modal modal-dialog d-flex',
       data: { menu: menu },
    });

    dialogRef.onClose.subscribe((dlgmenu) => {
      // console.log(menu, '..result');
    });
  }
}
